// Generated by Claude Code
import { Api, ApiError } from '#core/api/Api.ts'
import type { Currency } from '#core/entities/operations/parts/Part.ts'
import { CompanyCostRate, UserCostRate } from '#core/entities/operations/settings/CostRate.ts'

/**
 * API client for the hourly labour rates (`/operations/cost-rates`): the company
 * default and per-user overrides.
 */
export default class CostRatesApi extends Api<CostRatesApi> {
  private static readonly basePath = 'operations/cost-rates'

  constructor() {
    super()
  }

  /** Returns the company's default rate, or null when none is set (404). */
  public async getDefaultRate(): Promise<CompanyCostRate | null> {
    try {
      return await this.get<CompanyCostRate>(`${CostRatesApi.basePath}/default`, undefined, CompanyCostRate)
    } catch (err) {
      if (err instanceof ApiError && err.response?.status === 404) return null
      throw err
    }
  }

  /** Sets the company's default rate, entered in `currency`. */
  public async setDefaultRate(rate: number, currency: Currency): Promise<CompanyCostRate | null> {
    return this.put<CompanyCostRate>(`${CostRatesApi.basePath}/default`, { rate, price_currency: currency }, CompanyCostRate)
  }

  /** Returns the own rate of every user who has one; users without one fall back to the default. */
  public async listUserRates(): Promise<UserCostRate[]> {
    return (await this.get<UserCostRate[]>(`${CostRatesApi.basePath}/users`, undefined, UserCostRate)) ?? []
  }

  /** Returns the user's own rate, or null when they fall back to the default (404). */
  public async getUserRate(userId: string): Promise<UserCostRate | null> {
    try {
      return await this.get<UserCostRate>(`${CostRatesApi.basePath}/users/${userId}`, undefined, UserCostRate)
    } catch (err) {
      if (err instanceof ApiError && err.response?.status === 404) return null
      throw err
    }
  }

  /** Sets the user's own rate, entered in `currency`, overriding the company default. */
  public async setUserRate(userId: string, rate: number, currency: Currency): Promise<UserCostRate | null> {
    return this.put<UserCostRate>(`${CostRatesApi.basePath}/users/${userId}`, { rate, price_currency: currency }, UserCostRate)
  }

  /** Removes the user's own rate so the company default applies. */
  public async deleteUserRate(userId: string): Promise<void> {
    await this.delete(`${CostRatesApi.basePath}/users/${userId}`)
  }
}
